import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "status-fiction",
  "use": "status-fiction-usage",
  "viewBox": "0 0 58.34 58.34",
  "content": "<symbol viewBox=\"0 0 58.34 58.34\" id=\"status-fiction\"><circle cx=\"29.17\" cy=\"29.17\" r=\"29.17\" /><path d=\"M36.43 15.38a12.71 12.71 0 0 0-7.63-2.19 10.67 10.67 0 0 0-5.89 1.54q-3.8 2.41-4 8.2h5.87a6 6 0 0 1 1-3.25 3.64 3.64 0 0 1 3.34-1.56 3.77 3.77 0 0 1 3.29 1.27 4.72 4.72 0 0 1 .9 2.8 4.22 4.22 0 0 1-1 2.46 5.08 5.08 0 0 1-1.17 1.2 26.65 26.65 0 0 0-4.58 3.68c-.81.95-.88 2.38-1 4.42 0 .14.06.45.56.45h4.57a.5.5 0 0 0 .55-.49 5.55 5.55 0 0 1 .25-1.56 4.83 4.83 0 0 1 1.74-2.12l1.62-1.12a18 18 0 0 0 3.15-2.8 7.47 7.47 0 0 0 1.49-4.44 7.47 7.47 0 0 0-3-6.49zm-7.72 22.53A3.54 3.54 0 0 0 25 41.45a3.5 3.5 0 0 0 3.55 3.7 3.48 3.48 0 0 0 3.8-3.49 3.53 3.53 0 0 0-3.64-3.75z\" fill=\"#fff\" /></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/status-fiction.svg
// module id = ido2
// module chunks = 1